import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ITabsState } from 'new_shared/TabRouter';

const initialState: ITabsState = { viewName: 'home', params: { curso: null, ruta: null, key: null } };

const tabRouterStateSlice = createSlice({
	name: 'tabRouterState',
	initialState,
	reducers: {
		setTabRouterState: (state, action: PayloadAction<ITabsState>) => {
			return action.payload;
		}
	}
});

export const { setTabRouterState } = tabRouterStateSlice.actions;

export default tabRouterStateSlice.reducer;
